module.exports = __webpack_public_path__ + "images/emoji/arrow_lower_right.5e404233b77190a3d924.png";